import { LinearProgress, Stack } from '@mui/material';
import DateRangePicker from 'Global/Components/CommonComponents/DateRangePicker/DateRangePicker';
import EditableCustomizableSelect from 'Global/Components/EditableComponents/EditableCustomizableSelect/EditableCustomizableSelect';
import i18next from 'i18next';
import React from 'react';

const DataFilters = (data) => {
  const {
    inputParams,
    setRange,
    inputFilter_label,
    setInputFilter,
  } = data;

  const cachedDateRange =
    sessionStorage.getItem('dtr') &&
    JSON.parse(sessionStorage.getItem('dtr'));

  const inflv =
    sessionStorage.getItem('inflv') &&
    JSON.parse(sessionStorage.getItem('inflv'));

  return (
    <React.Fragment>
      {inputParams ? (
        <Stack>
          <DateRangePicker
            onChange={setRange}
            initialValue={{
              FromDate: cachedDateRange?.fmd,
              ToDate: cachedDateRange?.td,
            }}
          />
          <EditableCustomizableSelect
            isSingle={true}
            SelectableDataArray={inputParams?.TypeList}
            label={inputFilter_label}
            initialData={[
              {
                ItemContent: inflv
                  ? inputParams?.TypeList?.filter(
                      (fl) => fl.ItemValue === inflv
                    )[0]?.ItemContent
                  : 'ویزیت نشده',
                ItemValue: inflv
                  ? inputParams?.TypeList?.filter(
                      (fl) => fl.ItemValue === inflv
                    )[0]?.ItemContent
                  : 'ویزیت نشده',
              },
            ]}
            onChange={setInputFilter}
            isEnglish={i18next?.language === 'en'}
            enableInitialOnchange={true}
          />
        </Stack>
      ) : (
        <></>
      )}
    </React.Fragment>
  );
};

export default DataFilters;
